module.exports = __webpack_public_path__ + "static/media/integrations-module-group1.e12ad4e5.svg";